import { format } from "date-fns";

import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  reportData: {
    status: "idle",
    data: [],
    error: {},
  },
}

export const fetchAll = createAsyncThunk('allireport', async (data) => {
    const {token} = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/data/irrigation/YILI/all` 

       const response = await axios.get(url, 
                 { headers })
      return response.data
})

const irrigationAllSlice = createSlice({
  name: 'allireport',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchAll.pending.type]:(state, action) => {
      state.reportData = {
        status: "loading",
        data: {},
        crops: [],
        error: {},
      }
    },
    [fetchAll.fulfilled.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: action.payload,
        crops: action.payload.Crops,
        error: {},
      }
    },
    [fetchAll.rejected.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: {},
        crops: [],
        error: "unauthorized",
      }
    },
  }
})

export default irrigationAllSlice.reducer
